<script setup lang="ts">
import { computed } from 'vue';

import { useChatStore } from '#layers/ai/stores/chat';
import { toUiMessages } from '#layers/ai/utils/to-ui-messages';
import ContentBlockText from './ContentBlock/Text.vue';
import ContentBlockUiTool from './ContentBlock/UiTool.vue';
import AiChatThreadScrollContainer from './ScrollContainer.vue';

const chatStore = useChatStore();
const uiMessages = computed(() => toUiMessages(chatStore.messages));
</script>

<template>
	<AiChatThreadScrollContainer>
		<template v-for="(message, messageIndex) of uiMessages" :key="`message-${messageIndex}`">
			<template v-for="(block, blockIndex) of message.content" :key="`block-${messageIndex}-${blockIndex}`">
				<ContentBlockText
					v-if="block.type === 'text'"
					v-bind="block"
					:role="message.role"
					class="[&+*]:mt-6"
				/>
				<ContentBlockUiTool
					v-else-if="block.type === 'uiTool'"
					v-bind="block"
					class="[&+&]:mt-2! [&+*]:mt-6"
				/>
			</template>
		</template>
	</AiChatThreadScrollContainer>
</template>
